import React, { Component } from 'react'
import { MDBContainer, MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBIcon } from 'mdbreact';

export default class Badges extends Component {
  render() {
    return (
        	<div class="container white_background">
		<div class="row justify-content-center Concepts_intro no-gutters">
			<div class="col-0 col-sm-0 col-md-0 col-lg-4 col-xl-4 Concepts_intro_title_B ">
			    <p class="Concepts_line2">Badges</p>
			</div>
			<div class="col Concepts_intro_content justify-content-center">
				<div class="row Concepts_intro_brief justify-content-center no-gutters">
					<p class="badges_intro_brief">You can earn Badges for using Daily24 and being an excellent tracker!  For each badge that you earn, you will be entered into a raffle for the <font style={{color:"#EF4A81"}}>chance to win a $25 gift card.</font> Some badges are worth more than others. <font style={{color:"#3c5b89"}}>The more you track, the more badges you earn, and the more chances there are to win!</font> </p>
				</div>
                                        <div class="row badges">
                                        <div class="col-12 badges_title1">
                                                <p>One Time Badges </p>
                                        </div>
                                        <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                                <img class="badges_img" src="https://i.ibb.co/c8JCw2t/Letsgetstared-C-3x.png" alt="Letsgetstared-C-3x" border="0"/>
                                        </div>
                                        <div class="col-9 col-sm-9 col-md-9 col-lg-4 col-xl-4 badges_description">
                                                <p>Let's Get Started!</p>
                                                <p>Log in and use the app for the first time.</p>
                                        </div>
                                        <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                                <img class="badges_img" src="https://i.ibb.co/nBCPZfM/Feelthepower-C-3x.png" alt="Feelthepower-C-3x" border="0"/>
                                        </div>
                                        <div class="col-9 col-sm-9 col-md-9 col-lg-4 col-xl-4 badges_description">
                                                <p>Feel the POWER!</p>
                                                <p>Track every day of your POWER28.</p>
                                        </div>

                                        <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                                <img class="badges_img" src="https://i.ibb.co/0VW48qN/Halftwaycharged1time-C-3x.png" alt="Halftwaycharged1time-C-3x" border="0"/>
                                        </div>
                                        <div class="col-9 col-sm-9 col-md-9 col-lg-4 col-xl-4 badges_description">
                                                <p>Half Way Charged!</p>
                                                <p>POWER28 for at least 50% of the time</p>
                                        </div>

                                        <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                                <img class="badges_img" src="https://i.ibb.co/0rNvnYc/Perftct168-C-3x.png" alt="Perftct168-C-3x" border="0"/>
                                        </div>
                                        <div class="col-9 col-sm-9 col-md-9 col-lg-4 col-xl-4 badges_description">
                                                <p>Perfect 168!</p>
                                                <p>Track every single day that you are in the study!</p>
                                        </div>

                                </div>
                                <div class="row badges">
                                        <div class="col-12 badges_title1">
                                                <p>Streak Badges<br /><font style={{color:"#808080", fontSize: "16px"}}>(Reset Every 28 Days)</font></p>
                                        </div>
                                        <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                                <img class="badges_img" src="https://i.ibb.co/XkvxF8b/Bronze-C-3x.png" alt="Bronze-C-3x" border="0"/>
                                        </div>
                                        <div class="col-9 col-sm-9 col-md-9 col-lg-4 col-xl-4 badges_description">
                                                <p>Bronze Streak</p>
                                                <p>Track for 7 days in a row.</p>
                                        </div>
                                        <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                                <img class="badges_img" src="https://i.ibb.co/84CkTfs/Silver-C-3x.png" alt="Silver-C-3x" border="0"/>
                                        </div>
                                        <div class="col-9 col-sm-9 col-md-9 col-lg-4 col-xl-4 badges_description">
                                                <p>Silver Streak</p>
                                                <p>Track for 14 days in a row.</p>
                                        </div>
                                        <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                                <img class="badges_img" src="https://i.ibb.co/7rFr9hB/Gold-C-3x.png" alt="Gold-C-3x" border="0"/>
                                        </div>
                                        <div class="col-9 col-sm-9 col-md-9 col-lg-4 col-xl-4 badges_description">
                                                <p>Gold Streak</p>
                                                <p>Track for 21 days in a row.</p>
                                        </div>
                                        <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                                <img class="badges_img" src="https://i.ibb.co/YTqwdDW/Platinum-C-3x.png" alt="Platinum-C-3x" border="0"/>
                                        </div>
                                        <div class="col-9 col-sm-9 col-md-9 col-lg-4 col-xl-4 badges_description">
                                                <p>Platinum Streak</p>
                                                <p>Track for 28 days in a row.</p>
                                        </div>
                                </div>
                                <div class="row badges">
                                        <div class="col-12 badges_title1">
                                                <p>POWER Week Badges<br /><font style={{color:"#808080", fontSize: "16px"}}>(Reset Every Week on Monday)</font></p>
                                        </div>
                                        <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                                <img class="badges_img" src="https://i.ibb.co/Ldfr6N1/Chargingup-C-3x.png" alt="Chargingup-C-3x" border="0"/>
                                        </div>
                                        <div class="col-9 col-sm-9 col-md-9 col-lg-4 col-xl-4 badges_description">
                                                <p>Charging Up</p>
                                                <p>Track one day of your POWER Week</p>
                                        </div>

                                        <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                                <img class="badges_img" src="https://i.ibb.co/fXXCFnD/Halfwaycharged-C-3x.png" alt="Halfwaycharged-C-3x" border="0"/>
                                        </div>
                                        <div class="col-9 col-sm-9 col-md-9 col-lg-4 col-xl-4 badges_description">
                                                <p>Half Way Charged!</p>
                                                <p>4 days of POWER Week</p>
                                        </div>

                                        <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                                <img class="badges_img" src="https://i.ibb.co/Jtm62g2/Fullycharged-C-3x.png" alt="Fullycharged-C-3x" border="0"/>
                                        </div>
                                        <div class="col-9 col-sm-9 col-md-9 col-lg-4 col-xl-4 badges_description">
                                                <p>Fully Charged!</p>
                                                <p>Track every day of your POWER Week</p>
                                        </div>
                                        <div class="col-3 col-sm-3 col-md-2 col-lg-2 col-xl-2">
                                                <img class="badges_img" src="https://i.ibb.co/QK3tm7S/Overcharged-C-3x.png" alt="Overcharged-C-3x" border="0"/>
                                        </div>
                                        <div class="col-9 col-sm-9 col-md-9 col-lg-4 col-xl-4 badges_description">
                                                <p>Overcharged</p>
                                                <p>any days logged outside of POWER Week.</p>
                                        </div>
                                </div>
		<div class="row">
			<div class="col"></div>
			<div class="col-10 col-sm-9 col-md-8 col-lg-7 col-xl-6">
                <MDBNavLink class="nav-link" to="/makeUp">
				   <a href="#" class="Bottom_button_r">
				   <p>What happens if I miss my Power Week?</p>
				   </a>
                </MDBNavLink>
            </div>
			<div class="col"></div>
		</div>
			</div>
		</div>
	</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Badges.js